import { action, makeObservable, observable } from 'mobx';
import { InputHTMLAttributes } from 'react';
import { v4 as uuidv4 } from 'uuid';

export class SocialModel {
    readonly id: string;
    inputValue: string = '';
    selectValue: string = '';
    type: InputHTMLAttributes<HTMLInputElement>['type'] = 'text';
    
    constructor() {
        makeObservable(
            this,
            {
                inputValue: observable,
                selectValue: observable,
                type: observable,
                onInputChange: action,
                onSelectChange: action,
            },
            { autoBind: true }
        );
        this.id = uuidv4();
    }

    onInputChange(val: string) {
        this.inputValue = val;
    }

    onSelectChange(val: string) {
        this.selectValue = val;
    }
}
